(function() {
  const initColorGuide = () => {
    const trigger = document.querySelector('.js-open-color-guide');
    const drawer = document.querySelector('.color-guide-drawer');
    const overlay = document.querySelector('.color-guide-overlay');
    const closeBtns = document.querySelectorAll('.js-close-guide');
    const swatches = document.querySelectorAll('.js-swatch-select');
    const uiInput = document.querySelector('#custom-color-input-field'); // 用户看到的输入框

    if (!trigger || !drawer) return;

    // --- 核心提交逻辑 ---
    const syncToProductForm = (value) => {
      // 寻找 Shopify 的原生加购表单
      const productForms = document.querySelectorAll('form[action*="/cart/add"]');
      
      productForms.forEach(form => {
        // 检查表单内是否已有隐藏的颜色属性框
        let hiddenInput = form.querySelector('input[name="properties[Custom Color]"]');
        
        if (!hiddenInput) {
          // 如果没有，创建一个隐藏框并插入表单
          hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = 'properties[Custom Color]';
          form.appendChild(hiddenInput);
        }
        
        hiddenInput.value = value;
        console.log("Color synced to form:", form.id, "Value:", value);
      });
    };

    // 监听手动输入
    if (uiInput) {
      uiInput.addEventListener('input', (e) => {
        syncToProductForm(e.target.value);
      });
    }

    // --- 交互逻辑 ---
    trigger.onclick = (e) => {
      e.preventDefault();
      drawer.classList.add('is-open');
      overlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    };

    const closeAll = () => {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-visible');
      document.body.style.overflow = '';
    };

    closeBtns.forEach(btn => btn.onclick = closeAll);

    // 色卡选择
    swatches.forEach(swatch => {
      swatch.onclick = function() {
        const fullName = this.getAttribute('data-full-name');
        const shortName = this.getAttribute('data-color-only');
        
        // 更新 UI 输入框
        if (uiInput) uiInput.value = fullName;
        
        // 同步到真正的提交表单
        syncToProductForm(fullName);

        // 联动切换变体图片
        const variantOptions = document.querySelectorAll(`input[value="${shortName}" i], [data-value="${shortName}" i]`);
        variantOptions.forEach(opt => opt.click());

        closeAll();
      };
    });
  };

  initColorGuide();
  document.addEventListener('shopify:section:load', initColorGuide);
})();